
export default {
  ENDPOINT : 'https://ortodipaolo-561a1.firebaseio.com/',
  API_KEY : 'AIzaSyBnylowqbiWpGZ65CbZ-9W3C-9vOURZ0k0',
}


